import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { selectDealerProfile, selectAllCarImagesFolders, selectProviderCarsByBusinessLine } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { Alert } from 'src/app/public/car/models/alert.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { Car } from 'src/app/public/car/models/car.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';

@Component({
    selector: 'app-provider-posting',
    templateUrl: './provider-posting.component.html',
    styleUrls: ['./provider-posting.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ProviderPostingComponent implements OnInit {

  myBuyCars$: Observable<Car[]>;

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  
  myProfile$: Observable<Dealer>;

  businessLine: CarBusinessLine = CarBusinessLine.BUY;
  objectSource: ObjectSource = ObjectSource.BUY
  transactionStages: TransactionStage[] = [TransactionStage.ONGOING];
  transactionRole: TransactionRole = TransactionRole.PROVIDER

  TransactionStage = TransactionStage

  constructor(

    private store: Store, 
    private router: Router,
    private route: ActivatedRoute
    ) {

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);

      this.myProfile$ = store.select(selectDealerProfile);

      this.myBuyCars$ = store.select(selectProviderCarsByBusinessLine(this.businessLine))

    }

    ngOnInit() {

      //this.store.dispatch(DealerActions.fetchProviderCarsSubmit({businessLine: this.businessLine}));
      this.route.data.subscribe(
          data => {
            this.transactionStages = data['transactionStages'];
            this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.transactionStages }));
          }
        )
    }

  updateAlertStatus(alert: Alert){

    let temp: Alert = JSON.parse(JSON.stringify(alert));

    temp.active = !temp.active;

    this.store.dispatch(DealerActions.alertUpdateStatusSubmit({ businessLine: temp.criteria.businessLine!, alertId: temp.id, status: temp.active }));
  }

  executeAlert(alert: Alert){

    let crt: CarCriteria = JSON.parse(JSON.stringify(alert.criteria));
    crt.pageNumber = 0;
    crt.businessLine = undefined;

    this.router.navigate(
      ["/"+alert.criteria.businessLine!.toLocaleLowerCase()+"/search"],
      { queryParams: crt }
    );

  }

  editAlert(index: number){
    
  }

  deleteAlert(businessLine: CarBusinessLine, alertId: number){
    this.store.dispatch(DealerActions.alertDeleteSubmit({businessLine: businessLine, alertId: alertId}));  
  }
}
